<template>
    <div class="pt-2 flex items-start error transition-all duration-300" v-show="error != false" :class="[error == false ? 'opacity-0' : '']" :data-error-scroll-to="errorScrollTo">
        <IconFalse class="w-5 h-5 stroke-red-700 bg-red-700 shrink-0 rounded-full bg-opacity-10 mr-2" />

        <div class="error text-14" :class="[textClass]">
            <div v-html='error' />
            <slot name="errorAfter" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        error: { type: [Boolean, String], default: false },
        textClass: { type: String, default: 'text-error' },
        errorScrollTo: { type: [String, Boolean], default: false },
    },
}
</script>
